import React from "react";
import PropTypes from "prop-types";
import {
    fetchBusinessProgramList
} from "store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Table } from "components";
import {
    Row,
    Col,
    // Spin
    // Dropdown, Menu, Icon
} from "antd";
import PopMenu from "components/PopMenu";
import { MPA_LIST_TABLE_COLS } from "constants/table-columns";
import { List } from "immutable";
import { STATE_STATUS } from "constants/index";

// const createViewAction = action => {
//     const _ = () => (
//         <a href="javascript:void(0)" onClick={() => action()}>
//             View
//         </a>
//     );
//     _.displayName = "TableAction";
//     return _;
// };

class MpaView extends React.Component {
    componentDidMount() {
        this.props.fetchBusinessProgramList();
    }

    handleItemClick = () => {
        this.props.history.push("/app/schemes/new");
    };

    render() {
        if(this.props.programListStatus === STATE_STATUS.UNFETCHED || this.props.programListStatus === STATE_STATUS.FETCHING) {
            return "FETCHING";
        }
        return (
            <Row className={"p-5"}>
                <Col span={24}>
                    <PopMenu
                        icon={"plus"}
                        onItemClick={this.handleItemClick}
                        menuList={["Create Business Program"]}
                    />
                    <Table
                        columns={MPA_LIST_TABLE_COLS}
                        // data={new List(this.props.programListData && this.props.programListData.map(_ => {
                        //     let row = _;
                        //     row.action = createViewAction(
                        //         this.props.history.push.bind(null, `/app/schemes/${_.id}`)
                        //     )();
                        //     return row;
                        // })) || new List([])}
                        data={new List(this.props.programListData) || new List([])}
                        showTopSection={false}
                        noRowSelection={true}
                    />
                </Col>  
            </Row>
        );
    }
}

MpaView.propTypes = {
    permission: PropTypes.string,
    history: PropTypes.object,
    programListData: PropTypes.array,
    programListStatus: PropTypes.string,
    fetchBusinessProgramList: PropTypes.func
};

const mapStateToProps = state => ({
    programListStatus: state.schemes.getIn(["business_program_list", "status"]),
    programListData: state.schemes.getIn(["business_program_list", "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchBusinessProgramList
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps) (MpaView);